import graphql from "babel-plugin-relay/macro";

export const facilitiesDropdown = graphql`
    fragment FacilityFragments_FacilitiesDropdown on Facility @relay(plural: true) {
        id
        applicableVersion {
            displayName
        }
    }`